module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTW05-45Light.e300f0fb.woff2";